(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["srv-instagram-feed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cardCount = 50;

    const buildMarquee = (section) => {
      const source = section.querySelector('.srv-instagram__source');
      const marquee = section.querySelector('[data-srv-instagram-marquee]');
      const track = marquee?.querySelector('.srv-instagram__track');

      if (!source || !marquee || !track) return false;

      const posts = [];
      const seen = new Set();

      source.querySelectorAll('.instafeed-new-layout-item').forEach((item) => {
        const link = item.querySelector('a[href*="instagram.com"]');
        const image = item.querySelector('img[data-instafeed-src], img[src]');
        const href = link?.href;
        const src = image?.dataset.instafeedSrc || image?.currentSrc || image?.src;

        if (!href || !src || seen.has(href)) return;

        seen.add(href);
        posts.push({ href, src, alt: image.alt || 'Serviette on Instagram' });
      });

      if (!posts.length) return false;

      const makeGroup = (isClone = false) => {
        const group = document.createElement('div');
        group.className = 'srv-instagram__group';

        if (isClone) group.setAttribute('aria-hidden', 'true');

        for (let index = 0; index < cardCount; index += 1) {
          const post = posts[index % posts.length];
          const link = document.createElement('a');
          const image = document.createElement('img');

          link.className = 'srv-instagram__post';
          link.href = post.href;
          link.target = '_blank';
          link.rel = 'noopener nofollow';
          link.setAttribute('aria-label', `View Instagram post ${(index % posts.length) + 1}`);

          if (isClone) link.tabIndex = -1;

          image.src = post.src;
          image.alt = isClone ? '' : post.alt;
          image.loading = 'lazy';
          image.decoding = 'async';
          link.appendChild(image);
          group.appendChild(link);
        }

        return group;
      };

      track.replaceChildren(makeGroup(), makeGroup(true));
      marquee.hidden = false;
      return true;
    };

    const initialize = (section) => {
      if (buildMarquee(section)) return;

      const source = section.querySelector('.srv-instagram__source');
      if (!source) return;

      const observer = new MutationObserver(() => {
        if (buildMarquee(section)) observer.disconnect();
      });

      observer.observe(source, { childList: true, subtree: true });
    };

    document.querySelectorAll('.srv-instagram').forEach(initialize);

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.srv-instagram');
      if (section) initialize(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
